import { cls } from "@wss/cls";
import React, { ComponentProps, PropsWithChildren } from "react";
type ProductDetailsDescriptionProps = ComponentProps<"p">;
export function ProductDetailsCardDescription({
  children,
  className,
  ...rest
}: PropsWithChildren<ProductDetailsDescriptionProps>) {
  return <p {...rest} className={cls("block m-0 mt-auto p-0 pt-2 mb-1.5 h-12 overflow-hidden text-center text-[0.75em] font-semibold leading-tight no-underline text-green-500 group-hover:text-green-700", className)} data-sentry-component="ProductDetailsCardDescription" data-sentry-source-file="Description.tsx">
      {children}
    </p>;
}